<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-捐赠项目-添加
    -->
    <el-dialog
    title="修改"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改</div>

      <el-form-item label="类型" prop="type">

          <div v-if="form.type == 1">企业单位</div>
          <div v-if="form.type == 1">个人/非企业单位</div>
      </el-form-item>

      <el-form-item label="抬头名称" prop="type">
        <div >{{form.name}}</div>
      </el-form-item>

      <el-form-item label="税号" prop="type">
        <div >{{form.tax_numb}}</div>
      </el-form-item>

      <el-form-item label="电子邮箱" prop="type">
        <div >{{form.email}}</div>
      </el-form-item>

      <el-form-item label="申请人" prop="type">
        <div >{{form.user.nickName}} ({{form.user.mobile}})</div>

      </el-form-item>

 

      <el-form-item label="开票金额" prop="type">
        <div >{{form.price}} </div>

      </el-form-item>

      <el-form-item label="审核状态" prop="type">
        <span v-if="form.status== 1">未审核</span>
                  <span v-if="form.status== 2">已通过</span>
                  <span v-if="form.status== 3">未通过</span>
                  <span v-if="form.status== 4">请重新审核</span> 
      </el-form-item>

      <el-form-item label="不通过原因" prop="type" v-if="form.status == 3">

            <div>{{ form.reject_val }}</div>

      </el-form-item>


     
  
    
    
    <el-form-item label="电子发票："  v-if="form.types == 1" prop="model.image">
      <div class="draggable-list">
        <div   >
          <div class="item" style="position: relative;">
              电子发票
                

                  <div class="open" @click="opena(form.tax_url)">打开文件</div>  
              </div>
       
             
            </div>
        
      </div>
    </el-form-item>





    <div v-if="form.types == 2 && form.status == 2">
        <div v-if="form.delivery_status.value == 10 && form.types == 2">
          <!-- 去发货 -->
          <div class="common-form mt16">去发货</div>
          <el-form size="small" ref="form" :model="form" label-width="100px">
            <el-form-item label="物流公司">
              <el-select v-model="form.express_id" placeholder="请选择快递公司">
                <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index" :value="item.express_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物流单号">
              <el-input v-model="form.express_no" class="max-w460"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-else>
          <div class="common-form mt16">发货信息</div>
          <div class="table-wrap">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">物流公司：</span>
                  {{form.express? form.express.express_name:form.express_company }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">物流单号：</span>
                  {{ form.express_no }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">发货状态：</span>
                  {{ form.delivery_status.text }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">发货时间：</span>
                  {{ form.delivery_time }}
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>




    

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" v-if="form.types == 1" @click="onSubmit" :loading="loading">提交</el-button>
        <!-- 1 未审核  2  审核通过  3  审核不通过 4 重新审核 -->
        <el-button size="small" v-if="form.types == 2 && form.delivery_status.value == 10 && form.status == 2" type="primary" @click="onDelivery" :loading="loading">发货</el-button>
      </div>
    </el-form>
       <!--上传图片组件-->
       <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  
  </div>
</el-dialog>
  
</template>

<script>
import BillApi from '@/api/bill.js';
import Upload from '@/components/file/Upload';
import Uediter from '@/components/UE.vue';
import draggable from "vuedraggable";
var timestamp=new Date().toLocaleDateString();

export default {
  components: {
       /*编辑器*/
       Uediter,
    /*图片上传*/
    Upload: Upload,
    draggable,

  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
       /*富文本配置*/
       ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/

      form: {
        bannar:[],
        name: '',
        short_intro:"",
        intro:"",
        insti_id:0,
        money_target:0,
        rec_insti_id:0,
        type_id:1,
        note:"",
        p_time:new Date(timestamp),
        budget:[],
        plan:[],
        ability:"",
        about:"",
        d_note:"",//捐赠票据

        tax_url:[],
        express_no:"",
        express_id:0,


      },
      insti:{
        name:""
      },
      rec_insti:{
        name:""
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      isVideoUpload:false,
      cert_index:0,
      people_index:0,
      budget_index:0,
      isProductUpload:false,
      detail_index:0,
      open_insti:false,
      open_insti_rec:false,
      type:[],
      /*快递公司列表*/
      expressList: [],
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","bill_id"],
  methods: {
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      BillApi.detail({bill_id: self.bill_id},true).then(res => {
          self.form = res.data.detail;
          self.expressList = res.data.expressList;
          self.loading = false;
        })
        .catch(error => {});
    },
   opena(file){
        window.open(file)
    },
         /*发货*/
         onDelivery() {
        let self = this;
        let param = self.form;
        if (param.express_id == null) {
          this.$message.error('请选择物流公司');
          return;
        }
        if (param.express_no == '') {
          this.$message.error('请填写物流单号');
          return;
        }

        BillApi.delivery({
              param: param,
              bill_id: self.bill_id
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.$message({
              message: '发货成功',
              type: 'success'
            });
            self.dialogFormVisible("error")
          })
          .catch(error => {
            self.loading = false;
          });
      },

     /*上传*/
     openProductUpload() {

      this.isupload = true;
  
    },
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.tax_url.concat(e);
        this.$set(this.form, "tax_url", imgs);
      }
      this.isupload = false;
    },
         /*删除商品图片*/
    deleteImg(index) {
      this.form.tax_url.splice(index, 1);
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      form.tax_url = JSON.stringify( form.tax_url);
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;

          BillApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
      
  }
}
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

</style>



// WEBPACK FOOTER //
// src/views/plus/bill/index/part/edit.vue